import { authorizedReportsBffRequest } from "utils/api";
import SelfServiceReportDto from "./interfaces/dtos/SelfServiceReportDto";
import {
  mapFieldGroupDtoToModel,
  mapSelfServiceReportDataDtoToModel,
  mapSelfServiceReportDtoToModel,
  mapSelfServiceReportModelToDto,
} from "./dataMapper";
import { ToastError } from "components/Global/Toasts/Toasty";
import SelfServiceReport from "./interfaces/SelfServiceReport";
import FieldGroupDto from "./interfaces/dtos/FieldGroupDto";
import ReportData from "./interfaces/ReportData";
import ReportDataDto from "./interfaces/dtos/ReportDataDto";
import FieldConfig from "./interfaces/FieldConfig";

export const getSelfServiceReports = async () => {
  try {
    const reportDtos = (await authorizedReportsBffRequest(
      "/self-service-reports"
    )) as SelfServiceReportDto[];

    return reportDtos.map(mapSelfServiceReportDtoToModel);
  } catch (e) {
    ToastError("Unable to load reports.");
    throw e;
  }
};

export const getSelfServiceReport = async (reportId: string) => {
  try {
    const reportsDto = (await authorizedReportsBffRequest(
      `/self-service-reports/${reportId}`
    )) as SelfServiceReportDto;

    return mapSelfServiceReportDtoToModel(reportsDto);
  } catch (e) {
    ToastError("Unable to load the report.");
    throw e;
  }
};

export const saveSelfServiceReport = async (
  report: SelfServiceReport
): Promise<string> => {
  try {
    const reportDto = mapSelfServiceReportModelToDto(report);

    const reportId = await authorizedReportsBffRequest(
      "/self-service-reports",
      "PUT",
      reportDto
    );
    return reportId;
  } catch (e) {
    ToastError("Unable to save the report.");
    throw e;
  }
};

export const deleteSelfServiceReport = async (reportId: string) => {
  try {
    await authorizedReportsBffRequest(
      `/self-service-reports/${reportId}`,
      "DELETE"
    );
  } catch (e) {
    ToastError("Unable to delete the report.");
    throw e;
  }
};

export const getFieldGroups = async () => {
  try {
    const fieldGroupDtos = (await authorizedReportsBffRequest(
      "/self-service-reports/field-groups"
    )) as FieldGroupDto[];

    return fieldGroupDtos.map(mapFieldGroupDtoToModel);
  } catch (e) {
    ToastError("Unable to load report fields.");
    throw e;
  }
};

export const getSelfServiceReportData = async (
  reportId: string
): Promise<ReportData> => {
  try {
    const reportDataDto = (await authorizedReportsBffRequest(
      `/self-service-reports/${reportId}/data`
    )) as ReportDataDto;

    const reportData = mapSelfServiceReportDataDtoToModel(reportDataDto);

    return reportData;
  } catch (e) {
    ToastError("Unable to load report data.");
    throw e;
  }
};

export const getSelfServiceReportDataPreview = async (
  fieldConfigs: FieldConfig[]
): Promise<ReportData> => {
  try {
    const reportDataDto = (await authorizedReportsBffRequest(
      "/self-service-reports/data/preview",
      "POST",
      fieldConfigs
    )) as ReportDataDto;

    const reportData = mapSelfServiceReportDataDtoToModel(reportDataDto);

    return reportData;
  } catch (e) {
    ToastError("Unable to load report data.");
    throw e;
  }
};
